export var ScreenStatus;
(function (ScreenStatus) {
    ScreenStatus["UploadSuccess"] = "SCREEN_UPLOAD_SUCCESS";
    ScreenStatus["UploadError"] = "SCREEN_UPLOAD_ERROR";
    ScreenStatus["Uploading"] = "SCREEN_UPLOADING";
    ScreenStatus["Copying"] = "SCREEN_COPYING";
})(ScreenStatus || (ScreenStatus = {}));
